export enum ObservationAffair {
  DRIVER_APP = 'DRIVER_APP',
  ROADMAP = 'ROADMAP',
  ROUTE = 'ROUTE',
  PAX = 'PAX',
  VEHICLE = 'VEHICLE',
  DELAY = 'DELAY',
  OTHERS = 'OTHERS'
}
